import styled from 'styled-components'
import React, { useState } from 'react';

import Button from '../reusable/Button'
import Icon from '../reusable/Icon'


const Alert = ({ text, imgUrl, cta, onClick, mobileImgUrl }) => {
  const [click, toggleClick] = useState(false);

  return(
    <Wrapper>
      <Left>
        <TextWrap>
          <Title>{text}</Title>
        </TextWrap>
        {cta === "Get in touch" ?
          <ButtonsWrapper>
            <Button onClick={onClick} text={cta} />
            {!click ?
              <ButtonCustome onClick={()=>toggleClick(true)}>Or leave your email </ButtonCustome>
              :
              <form action="/thank-you" name="email" method="post" >
                <input type="hidden" name="form-name" value="email" />
                <MailWrapper>
                  <Label>
                      <YourMailTextWrapper
                          type='email'
                          name='email'
                          placeholder='Enter your email'
                      />
                  </Label>
                    <Wrap type='submit'>
                      <Icon icon="arrRight" width={25} height={12} margin="0px 0px 0px 16px" />
                    </Wrap>
                </MailWrapper>
              </form>
            }
          </ButtonsWrapper>
          :
          <Button onClick={onClick} text={cta} />
        }
      </Left>
      <Right>
        <ImgMobile width="100%" height="100%" src={mobileImgUrl ? mobileImgUrl : imgUrl} alt="" />
        <Img width="100%" height="100%" src={imgUrl} alt="" />
      </Right>
    </Wrapper>
  )
}

export default Alert


const Wrapper = styled.div(props => ({
  display:"flex",
  alignItems:"center",
  justifyContent:"space-between",
  margin:"0px auto",
  paddingTop:108,
  minHeight:"calc(100vh - 140px)",
  "@media (max-width: 1050px)": {
    minHeight:"calc(50vh)",
  },
  "@media (max-width: 650px)": {
    flexDirection:"column-reverse",
    justifyContent:"center",
    minHeight:"calc(100vh - 140px)",
    paddingTop:72,
  },
}));

const Left = styled.div(props => ({
  "@media (max-width: 650px)": {
    maxWidth:340,
    width:"100%",
  },
}));

const Right = styled.div(props => ({
  width:"34%",
  display:"flex",
  alignItems:"center",
  justifyContent:"flex-end",
  "@media (max-width: 650px)": {
     justifyContent:"center",
     width:"100%",
  },
}));

const TextWrap = styled.div(props => ({
  maxWidth:722,
  marginRight:100,
  marginBottom:88,
  "@media (max-width: 1400px)": {
    maxWidth:550,
  },
  "@media (max-width: 1200px)": {
    maxWidth:410,
  },
  "@media (max-width: 880px)": {
    maxWidth:250,
    marginRight:0,
    marginTop:48,
    marginBottom:48,
  },
  "@media (max-width: 650px)": {
    marginTop:48,
    marginBottom:12,
  },
}));

const Title = styled.h2(props => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "70px",
  lineHeight: "105px",
  "@media (max-width: 1400px)": {
    fontSize: "54px",
    lineHeight: "85px",
  },
  "@media (max-width: 1200px)": {
    fontSize: "40px",
    lineHeight: "65px",
  },
  "@media (max-width: 880px)": {
    fontSize: "24px",
    lineHeight: "36px",
  },
}));

const Img = styled.img(props => ({
  maxWidth:300,
  maxHeight:"calc(100vh - 100px)",
  width:"100%",
  "@media (max-width: 750px)": {
    display:"none"
  },
}));

const ImgMobile = styled.img(props => ({
  display:"none",
  "@media (max-width: 750px)": {
    display:"block",
    marginTop:14,
    maxWidth:300,
    maxHeight:"calc(100vh - 100px)",
    width:"100%",
  },
}));

const ButtonsWrapper = styled.div(props => ({
 display:"flex",
 "@media (max-width: 1200px)": {
    flexDirection:"column",
    alignItems:"flex-start",
  },
}));

const ButtonCustome = styled.button(props => ({
  color:"#000",
  background:"#fff",
  display:"flex",
  border:"1px solid #000",
  cursor:"pointer",
  whiteSpace:"no-break",
  alignItems:"center",
  transition:"0.2s ease-in-out",
  height:64,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "21px",
  outline:"none",
  paddingRight:40,
  paddingLeft:40,
  ":hover":{
    color:"#fff",
    background:"#000",
  },
  "@media (max-width: 1200px)": {
    marginTop:20,
  },
  "@media (max-width: 650px)": {
    width:"100%",
  },
}));


const MailWrapper = styled.div(props => ({
  display: "flex",
  alignItems:"center",
  "@media (max-width: 1200px)": {
    marginTop:20,
  },
  "@media (max-width: 650px)": {
    width:"200%",
    maxWidth:290,
  },
}))

const Label = styled.label(props => ({
  width:380,
  "@media (max-width: 1000px)": {
    width:300,
  },
  "@media (max-width: 650px)": {
    width:"100%",
  },
}))

const Wrap = styled.button(props => ({
  color:"#000",
  background:"#fff",
  display:"flex",
  border:"none",
  cursor:"pointer",
  whiteSpace:"no-break",
  alignItems:"center",
  transition:"0.2s ease-in-out",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "21px",
  outline:"none",
  padding:0,
  margin:0,
}))

const YourMailTextWrapper = styled.input(props => ({
  width:"calc(100% - 80px)",
  height: 62,
  color: "#FFFFFF",
  background:"#000",
  borderRadius:0,
  paddingRight:40,
  paddingLeft:40,
  border: "none",
  outline: "none",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  "::placeholder":{
    color: "#fff",
    opacity: 1,
  },
}))


